import { useQuery } from '@tanstack/vue-query'

import { explorerApi } from '~/api/client'
import { EvmTrxPendingStatusInfo } from '~/api/repository'
import { workerTransactionPendingStatusKey } from '~/api/service/query-keys.const'

export const useFetchTransactionPendingStatus = (trxHash: string) => {
  return useQuery([ ...workerTransactionPendingStatusKey, trxHash ], (): Promise<EvmTrxPendingStatusInfo> => {
    return explorerApi.evmStatusWorker.getEvmTransactionPendingStatus({ trxHash }).then((res: EvmTrxPendingStatusInfo) => {
      return pendingStatusDto(res)
    })
  }, { enabled: false })
}

const pendingStatusDto = (status: EvmTrxPendingStatusInfo): EvmTrxPendingStatusInfo => {
  return status
}